import React from "react";
import {
  StyledVenueBroadcasterBar,
  StyledVenueBroadcasterWrapper,
} from "./StyledVenueBroadcasterBar";

function DividedVenueBroadcaster({ venue, mergedProvidersText }) {
  return (
    <StyledVenueBroadcasterWrapper className="mls-c-venue-broadcaster-bar --single-broadcaster">
      {venue.name && (
        <StyledVenueBroadcasterBar>{venue.name}</StyledVenueBroadcasterBar>
      )}
      {mergedProvidersText && (
        <StyledVenueBroadcasterBar>
          {mergedProvidersText}
        </StyledVenueBroadcasterBar>
      )}
    </StyledVenueBroadcasterWrapper>
  );
}

export default DividedVenueBroadcaster;
